<template>
  <div class="vx-row">
    <vx-card class="mb-base">
      <div class="fourth-sim pt-0">
        <div class="vx-row">
          <div class="vx-col w-1/2">
            <div class="border border-solid border-white p-5">
              <h1 class="mb-4">Command</h1>
              <div class="ubuntu-font">
                <h3 class="mb-2">
                  [root@webserver log]#
                  <span class="clickable-command" @click="showOutput('getenforce')">getenforce</span>
                </h3>
                <h3 class="mt-2 mb-2">
                  [root@webserver log]#
                  <span class="clickable-command" @click="showOutput('getsebool')">getsebool -a | grep httpd</span>
                </h3>
                <h3 class="mt-2 mb-2">
                  [root@webserver log]#
                  <span class="clickable-command" @click="showOutput('netstat')">netstat -antp</span>
                </h3>
                <!-- Add more commands similarly -->
              </div>
            </div>
          </div>
          <div class="vx-col w-1/2">
            <div class="border border-solid border-white p-5">
              <h1 class="mb-4">Answer</h1>
              <h3>[root@webserver log]#</h3>
              <v-select placeholder="Select An Answer" class="w-full mt-4" :options="answers" v-model="selected" />
            </div>
          </div>
        </div>
      </div>
    </vx-card>

    <!-- Output Modal -->
    <div v-if="showModal" class="modal" @click.self="showModal = false">
      <div class="modal-content terminal-box">
        <div class="terminal-header">
          <span class="dot red close" @click="showModal = false"></span>
          <span class="dot yellow"></span>
          <span class="dot green"></span>
        </div>
        <pre class="terminal-output">{{ commandOutput }}</pre>
      </div>
    </div>
  </div>
</template>

<script>
import Prism from 'vue-prism-component';
import vSelect from 'vue-select';
import shuffle from 'shuffle-array';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      answers: [
        { id: 1, label: 'systemctl restart nginx' },
        { id: 2, label: 'setsebool -P httpd_read_user_content -1' },
        { id: 3, label: 'restorecon -rv /home/comptia/html' },
        { id: 4, label: 'kill -HUP 3431' },
        { id: 5, label: 'sysctl -w net.ipv4 ip_forward = 1' },
        { id: 6, label: 'chown -R Comptia: /home/comptia/html/' },
        { id: 7, label: 'firewall-cmd --zone-public --service=http --permanent' },
        { id: 8, label: 'chmod 777 /home/comptia/html/' },
        { id: 9, label: 'setfacl -m g:comptia:rwx /home/comptia/html/' },
        { id: 10, label: 'cp -R /home/comptia/html /var/www/html' },
      ],
      selected: null,
      showModal: false,
      commandOutput: '',
    };
  },
  methods: {
    markSimulation() {
      let totalScore = 0;
      if (this.selected && this.selected.id === 1) {
        totalScore++;
      }
      if (totalScore === this.dataLocal.simulation.totalScore) {
        return this.$emit('simulation_full_correct', totalScore);
      }
      this.$emit('simulation_getting_there', totalScore);
    },
    showOutput(command) {
      const outputs = {
        getenforce: 'Enforcing',
        getsebool: 'httpd_anon_write --> off\nhttpd_builtin_scripting --> on',
        netstat: 'Proto Recv-Q Send-Q Local Address           Foreign Address         State       PID/Program name\n...',
        // Add sample outputs for other commands
      };
      this.commandOutput = outputs[command] || 'No output available for this command.';
      this.showModal = true;
    },
  },
  components: {
    Prism,
    vSelect,
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.answers = shuffle(this.answers);
  },
};
</script>

<style>
.clickable-command {
  cursor: pointer;
  color: #007bff;
  transition: color 0.3s;
}
.clickable-command:hover {
  color: #0056b3;
}

.modal {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1000;
}

.modal-content {
  background-color: #2d2d2d;
  color: #00ff00;
  padding: 20px;
  border-radius: 8px;
  max-width: 600px;
  width: 80%;
  text-align: left;
  position: relative;
  font-family: monospace;
}

.close {
  cursor: pointer;
  color: #ffffff;
  font-size: 24px;
}

.terminal-box {
  border: 1px solid #333;
  border-radius: 8px;
  padding: 15px;
}

.terminal-header {
  display: flex;
  gap: 6px;
  padding: 5px 0;
}

.dot {
  height: 12px;
  width: 12px;
  border-radius: 50%;
  display: inline-block;
}

.red {
  background-color: #ff605c;
}

.yellow {
  background-color: #ffbd44;
}

.green {
  background-color: #00ca4e;
}

.terminal-output {
  margin-top: 10px;
  color: #00ff00;
  white-space: pre-wrap;
}
</style>
